import HotelSearchResultsDisplay from './HotelSearchResultsDisplay';

export default HotelSearchResultsDisplay;
